module.exports = __webpack_public_path__ + "fonts/iconfont.d1fe1af9.eot";